import React from "react";
import PropTypes from "prop-types";
import { Alert as RSAlert } from "reactstrap";

/**
 * 站內統一的 Alert（封裝 reactstrap Alert）。
 *
 * 為何要包一層：reactstrap 9 把內部的 <Fade> 從 class 改成 function component,
 * 改用內部 addDefaultProps 自帶 timeout,不再暴露靜態 `Fade.defaultProps`。
 * 但 Alert 仍讀 `Fade.defaultProps`(現為 undefined)來組 transition,導致傳給
 * Fade 的 timeout 變成 undefined,觸發 PropTypes 警告:
 *   「The prop `timeout` is marked as required in `Fade`, but its value is `undefined`」
 * (Alert 常出現在 Modal 內 → 看起來像「開 Modal 就噴」)。
 *
 * 顯式補上 transition.timeout 即可消警告;150ms 即 reactstrap 淡入淡出的預設值,
 * 行為不變。呼叫端仍可用 transition 覆寫。
 */
/**
 * 版面依 Figma(21:4484 資訊 / 22:6138 危險):flex、padding 16、gap 12、
 * radius 6、1px 框線、12px 字;左側固定一個 Bootstrap Icons 的
 * `exclamation-triangle-fill`(設計稿兩種變體用的都是這一顆)。
 * 不要圖示時傳 icon={false},換別顆傳 icon="bi-info-circle-fill"。
 */
export const Alert = ({ transition, icon = "bi-exclamation-triangle-fill", children, ...rest }) => (
  <RSAlert transition={{ timeout: 150, ...transition }} {...rest}>
    {icon ? <i className={`bi ${icon}`} aria-hidden="true" /> : null}
    <span>{children}</span>
  </RSAlert>
);
Alert.propTypes = {
  // 交給 reactstrap Alert 的 transition props（timeout 已預設補上）
  transition: PropTypes.shape({ timeout: PropTypes.number }),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]),
  children: PropTypes.node,
};

export default Alert;
